import styled from 'styled-components';

const TextBoxLabel = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export default TextBoxLabel;
